export const sanitizeOrganizationValidation = (e: any) => {
  const data = e?.response?.data;
  if (Array.isArray(data?.payload)) {
    if (
      data.payload.includes('Organization address must be at least 5 characters') &&
      data.payload.includes('Organization billing address must be at least 5 characters')
    ) {
      data.payload = data.payload.filter(
        (msg: string) => msg !== 'Organization billing address must be at least 5 characters'
      );
    }
  }
};
